export default __webpack_public_path__ + "static/media/regional_logo.783bc2da.png";